import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CourseSelection from "@/pages/CourseSelection";
import Registration from "@/pages/Registration";
import Confirmation from "@/pages/Confirmation";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <div
        className="app-bg"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/brand/paper-bg.jpg)` }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CourseSelection />} />
          <Route path="/register/:courseId" element={<Registration />} />
          <Route path="/payment/:orderId" element={<Navigate to="/" replace />} />
          <Route path="/confirmation/:orderId" element={<Confirmation />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
